Monitoring.Views ||= {}

class AccountSettings.AcdSettingForFilterView extends Backbone.View
  template: JST["backbone/templates/account_settings/acd_setting/acd_setting_for_filter"]
  tagName: 'tr'

  events:
    'change #acd-active': 'onChangeActive'
    'change #acd-prioritize-non-replied': 'onChangePrioritize'
    'change #acd-filter-options-filter': 'onChangeFilterOptions'
    'change #acd-filter-options-order': 'onChangeFilterOptions'

  initialize: (@options = {}) ->
    @teamName = @options.team
    @settings = @options.settings

  render: =>
    @$el.html(@template(@))
    @initializeToggle()
    @prioritizationView = new AccountSettings.PrioritizationView({prioritizations: @settings })
    @$el.find('#prioritization-selection-container').append(@prioritizationView.render().el)
    @assignationLimitView = new AccountSettings.AssignationLimitSelectorView(maxLimit: 10, currentLimit: @_currentLimit())
    @$el.find('#assignation-limit-container').append(@assignationLimitView.render().el)
    if @settings.active then @assignationLimitView.enable() else @assignationLimitView.disable()
    @active = @settings.active
    @

  initializeToggle: ->
    @$el.find('#acd-active').bootstrapToggle(@active)
    @$el.find('#acd-prioritize-non-replied').bootstrapToggle({
      # 'on' and 'off' options can be set here
    })

  onChangeFilterOptions: ->
    selectedFilterOptions = @$el.find("#acd-filter-options-filter option:selected")
    selectedOrderOptions = @$el.find("#acd-filter-options-order option:selected")
    selectedFilterValues = _.map(selectedFilterOptions, (opt) -> opt.value)
    selectedOrderValues = _.map(selectedOrderOptions, (opt) -> opt.value)
    new_filter_order = [{filter: selectedFilterValues[0], order: selectedOrderValues[0]}]
    @settings.filter_order = new_filter_order

  onChangeActive: ->
    active = @$el.find('#acd-active').prop('checked')
    @settings.active = active
    @active = active
    if active == true
      @enableFilterSelector()
      @enableLimitSelector()
    else
      @disableFilterSelector()
      @disableLimitSelector()

  getSelectedSetting: ->
    {
      active: @active,
      prioritization: @prioritizationView.prioritizationSettings(),
      assignation_limit: @assignationLimitView.getAssignationLimit()
    }

  disableFilterSelector: ->
    @prioritizationView.disableFilterSelector()
    non_replied_switch = @$el.find('#acd-prioritize-non-replied')
    non_replied_switch.attr('disabled', true)
    non_replied_switch.parent().attr('disabled', true)


  enableFilterSelector: ->
    @prioritizationView.enableFilterSelector()
    non_replied_switch = @$el.find('#acd-prioritize-non-replied')
    non_replied_switch.attr('disabled', false)
    non_replied_switch.parent().attr('disabled', false)

  enableLimitSelector: =>
    @assignationLimitView.enable()

  disableLimitSelector: =>
    @assignationLimitView.disable()

  _currentLimit: =>
    @settings.assignation_limit || 0
